/** Dispatch contract selection to Analytics Hub (Stable deep analysis). */
import type { ContractHistoricalParams } from '../types/contractHistorical';
import type { ScannerData } from '../types/ScannerData';
import { getExpiryFromRecord } from './filterUtils';
import { columnKeyToHistoricalSource } from './dataTableHistoricalSource';

export const ANALYTICS_CONTRACT_SELECTED_EVENT = 'analytics-contract-selected';

export function dispatchAnalyticsContractSelected(contract: ContractHistoricalParams): void {
  window.dispatchEvent(
    new CustomEvent(ANALYTICS_CONTRACT_SELECTED_EVENT, { detail: { contract } }),
  );
}

export function openContractInAnalyticsHub(contract: ContractHistoricalParams): void {
  window.dispatchEvent(new CustomEvent('navigate-to-tab', { detail: { tab: 'analytics-hub' } }));
  dispatchAnalyticsContractSelected(contract);
}

export function historicalParamsFromScannerRow(row: ScannerData, columnKey = 'Volume'): ContractHistoricalParams {
  const expiry = getExpiryFromRecord(row) || (row['Expiry Date'] as string) || '';
  const expiryStr = typeof expiry === 'string' ? expiry : '';
  return {
    underlying: String(row.Underlying || ''),
    strike: (Number(row.Strike) || row.Strike) ?? '',
    expiry: expiryStr,
    optionType: ((row['Option Type'] as string) || 'CALL') as 'CALL' | 'PUT',
    source: columnKeyToHistoricalSource(columnKey),
  };
}
